import {Action} from 'redux';

import {createAction} from '@reduxjs/toolkit';

import {MetrikaGoal, MetrikaParam} from 'client/common/types';

export const SEND_GOALS = 'SEND_GOALS';
export const SEND_PARAMS = 'SEND_PARAMS';

export const sendGoals = createAction<SendGoalsPayload>(SEND_GOALS);
export const sendParams = createAction<SendParamsPayload>(SEND_PARAMS);

export type SendGoalsPayload = MetrikaGoal[];

export type SendParamsPayload = Array<MetrikaParam | string | number>;

export interface SendGoalsAction extends Action {
    payload: SendGoalsPayload;
}

export interface SendParamsAction extends Action {
    payload: SendParamsPayload;
}
